import { render } from "./AddProductDepot.vue?vue&type=template&id=2a9d9cba"
import script from "./AddProductDepot.vue?vue&type=script&lang=js"
export * from "./AddProductDepot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__